import Tippy from '@tippyjs/react';

export const getDefaultColumns = ({ oppositeLabel }) => [
  {
    field: 'name',
    headerName: 'States',
    flex: 1,
    checkboxSelection: (params) => !params.data?.isBlocked,
    headerCheckboxSelection: true,
    headerCheckboxSelectionFilteredOnly: true,
    cellRenderer: (params) => {
      if (!params.data?.isBlocked) return params.value;

      return (
        <Tippy
          content={`This state is already used for ${oppositeLabel} for this provider.`}
          className="tippy-dark"
          arrow
          appendTo={() => document.body}>
          <span className="text-neutral-400">{params.value}</span>
        </Tippy>
      );
    }
  }
];
